import React from 'react';
import { useParams } from 'react-router-dom';
import './PaymentSuccess.css';

const ExamConfirmation = () => {
  const { invoiceId } = useParams(); // Get invoiceId from URL parameters

  return (
    <div className="payment-success-container">
      <div className="payment-success-card">
        <h1 className="payment-success-title">Exam Appointment Confirmed!</h1>
        <p className="payment-success-message">
          Congratulations! Your exam appointment {invoiceId ? `with Invoice ID: ${invoiceId}` : ''} has been successfully booked.
        </p>
        <p className="payment-success-instructions">
          Please check your email for your appointment details, including date, time, and preparation instructions.
        </p>
        <a href="/" className="payment-success-button">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default ExamConfirmation;